import { Injectable } from '@angular/core';
import { Observable } from 'rxjs'; 
import { createAuthorizationHeader } from 'src/app/utils/security/headers';
import { dns } from 'src/app/global.config';
import { HttpClient } from '@angular/common/http';
import { Mission, RouteLegs, TrackingMission } from '../data-management.model';
import { DeliveryPoiDto, RouteSegment } from '.';

@Injectable({
  providedIn: 'root'
})
export class MissionService {
  selectedMission: Mission | null = null;

  constructor(private http: HttpClient) {}

  getMissions(): Observable<Mission[]> {
    let headers = createAuthorizationHeader();
    let options = { headers: headers };
    return this.http.get<Mission[]>(dns + "missions", options);
  }

  add(payload: Mission): Observable<Mission> {
    let headers = createAuthorizationHeader();
    let options = { headers: headers };
    return this.http.post<Mission>(dns + "missions", payload, options);
  }

  update(payload: Mission): Observable<Mission> {
    let headers = createAuthorizationHeader();
    let options = { headers: headers };
    return this.http.put<Mission>(dns + "missions", payload, options);
  }

  tracking(missionId: number, vehicleId: number): Observable<TrackingMission> {
    let headers = createAuthorizationHeader();
    let options = { headers: headers };
    return this.http.get<TrackingMission>(dns + "missions/" + missionId + "/tracking/" + vehicleId, options);
  }

  delete(missionId: number): Observable<boolean> {
    let headers = createAuthorizationHeader();
    let options = { headers: headers };
    return this.http.delete<boolean>(dns + "missions/" + missionId, options);
  }

  getRouteSegments(points: DeliveryPoiDto[]): Observable<RouteSegment[]> {
    let headers = createAuthorizationHeader();
    let options = { headers: headers };
    return this.http.post<RouteSegment[]>(dns + "rimtrack/durations_distances_api/getListToTrajet", points, options);
  }

  // Transform RouteLegs to RouteSegment format
  transformTrajetToListTrajet(trajet: RouteLegs, providedCoordinates?: [number, number][]): RouteSegment[] {
    const coordinates = providedCoordinates || [
      [trajet.lngPOISource, trajet.latPOISource],
      [trajet.lngPOITarget, trajet.latPOITarget]
    ];
    return [
      {
        fromName: trajet.labelPOISource,
        toName: trajet.labelPOITarget,
        coordinates: coordinates,
        distance:0,
        duration:0
      }
    ];
  }

  // Find RouteLegs by matching RouteSegment.fromName to RouteLegs.labelPOITarget and RouteSegment.toName to RouteLegs.labelPOISource
  findTrajetByListTrajet(segment: RouteSegment, trajets: RouteLegs[]): RouteLegs | null {
    return trajets.find(trajet => 
      trajet.labelPOITarget === segment.fromName && 
      trajet.labelPOISource === segment.toName
    ) || null;
  }

  getMissionExcel(id:number) : Observable<Blob>{
      let headers = createAuthorizationHeader();    
      return this.http.get<Blob>(`${dns}missions/excel/th/`+id,{ headers: headers, responseType: 'blob' as 'json' });
  }
}